/**
 * created by tian ruo jun
 组装插件需要的数据
 *
 */
import React, {Component} from 'react';
import BaseComponent from "../../../base/BaseComponent";
import {getInfoFromLocalStorage} from "../../../actions";
import $Jq from "jquery";

export default class PlugInData extends BaseComponent {
    // 获取信息
    getData = (content, callback) => {
        this.getPicList((res) => {
            let pictureList = res;
            let userInfo = this.getUserInfo();
            let data = {userInfo, pictureList};
            if (content) {
                data["content"] = this.formatContent(content)
            }
            data["origin"] = window.location.origin;
            data["token"] = this.getInfoFromLocalStorage("Token");
            data["refreshToken"] = this.getInfoFromLocalStorage("refreshToken");
            data["expireTime"] = this.getInfoFromLocalStorage("expireTime");
            callback&&callback(data)
        });
    };

    // 格式化编辑器内容（将内容进行分段，并塞到数组中）
    formatContent(html) {
        html = html
            .replace(/(<img.*?\/>)/gi, "<p>$1</p>")
        ;
        var $html = $Jq(html);
        var list = [];
        function consoleElement(_html) {
            $Jq.each(_html, function (i, el) {
                // if(el) {
                //     if(el.childNodes && el.childNodes.length) {
                //         consoleElement(el.childNodes);
                //     } else {
                //         if(el.nodeName.indexOf("text") >-1 && el.textContent && el.textContent.trim()) {
                //             list.push(el.textContent.trim());
                //         }
                //         if(el.nodeName.indexOf("IMG") >-1 && el.outerHTML) {
                //             list.push(el.outerHTML);
                //         }
                //         // if (
                //         //     el &&
                //         //     (
                //         //         el.innerText
                //         //         ||
                //         //         (el.outerHTML && el.outerHTML.indexOf("src") > -1)
                //         //     )) {
                //         //     list.push(el.outerHTML);
                //         // }
                //     }
                // }
                if ($Jq(el).children().length > 0 && ($Jq(el).find("p").length > 0 || $Jq(el).find("div").length > 0 || $Jq(el).find("img").length > 0)) {
                    var children = $Jq(el).children();
                    consoleElement(children)
                } else {
                    // $Jq(el).find("br").remove();
                    if (
                        el &&
                        (
                            el.innerText
                            ||
                            (el.outerHTML && el.outerHTML.indexOf("src")>-1)
                        )) {
                        list.push(el.outerHTML);
                    }
                }
            })
        }
        consoleElement($html);
        console.log("formatContent",list);
        return list;
    };

    // 获取当前用户信息
    getUserInfo = () => {
        let currentUser = getInfoFromLocalStorage("currentUser");
        return currentUser
    };

    // 判断是否有资源库权限
    hasZykPermission = () => {
        // value":"personalResources", "name":"个人资源",
        // "value":"unitResources", "name":"单位资源",
        let menu = getInfoFromLocalStorage("menu");
        let hasPersonalResources = this.hasZyPermission({menu,value: "personalResources", key: "menuCode"});
        let hasUnitResources = this.hasZyPermission({menu,value: "unitResources", key: "menuCode"});
        console.log("拥有个人资源库图片菜单",hasPersonalResources);
        console.log("拥有单位资源库图片菜单",hasUnitResources);
        return {hasPersonalResources, hasUnitResources}
    };

    // 判断是否有某资源库模块权限
    hasZyPermission = ({menu, value, key}) => {
        if(menu && menu.length) {
            return menu.some(item=> {
                if(item[key] === value) {
                    return true
                } else if(item.child && item.child.length) {
                    return this.hasZyPermission({menu: item.child, value, key})
                } else {
                    return false
                }
            })
        } else {
            return false
        }
    };

    // 获取图片列表
    getPicList = async (call) => {
        console.log("getPicList");
        // value":"personalResources", "name":"个人资源",
        // "value":"unitResources", "name":"单位资源",
        let {hasPersonalResources, hasUnitResources} = this.hasZykPermission();
        let picList = [];
        if(hasPersonalResources) {
            try {
                let personPicList = await this.getPersonPicList();
                picList = [...picList, ...personPicList]
            } catch (e) {
                console.log(e.toString())
            }
        }
        if(hasUnitResources) {
            try {
                let deptPicList = await this.getDeptPicList();
                picList = [...picList, ...deptPicList]
            } catch (e) {
                console.log(e.toString())
            }
        }
        console.log("当前人的个人资源和部门资源图片列表",picList);
        call&&call(picList);
    };

    // 获取个人图片列表
    getPersonPicList = () => {
        return new Promise((resolve, reject)=>{
            this.request({
                url: "/search-server/search/getList/picture/person",
                body: {
                    "pageNum": 1,
                    "pageSize": 9999,
                    "keyword": ""
                },
                method: "post",
                contentType: 'json',
                callBack: (res) => {
                    let zykPicList = [];
                    if (res && res.data) {
                        zykPicList = res.data
                    }
                    resolve(zykPicList)
                    // call&&call(zykPicList)
                },
                errorCallBack: (e) => {
                    resolve([])
                }
            })
        })
    };

    // 获取部门图片列表
    getDeptPicList = () => {
        return new Promise((resolve, reject)=>{
            this.request({
                url: "/search-server/search/getList/picture/dept",
                body: {
                    "pageNum": 1,
                    "pageSize": 9999,
                    "keyword": ""
                },
                method: "post",
                contentType: 'json',
                callBack: (res) => {
                    let zykPicList = [];
                    if (res && res.data) {
                        zykPicList = res.data
                    }
                    resolve(zykPicList)
                    // call&&call(zykPicList)
                },
                errorCallBack: (e) => {
                    resolve([])
                }
            })
        })
    };

}